//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { ProductCardModel } from '../Models/MpCard/ProductCardModel';
import { GetProductCardOptions } from '../Models/MpCard/GetProductCardOptions';
import { TransferProductCardsOptions } from '../Models/MpCard/TransferProductCardsOptions';
import { ProductCardVariantUpdateModel } from '../Models/MpCard/ProductCardVariantUpdateModel';
import { LinkVariantRequest } from '../Models/MpCard/LinkVariantRequest';

import { boundClass } from 'autobind-decorator';
import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { encodeUrlParameter, getAxiosData } from '../../../common/urlUtility';
@boundClass export class MpCardController
{
  
  private readonly axios: AxiosInstance
  
  constructor (axios: AxiosInstance)
  {
    this.axios = axios
  }
  getProductCard(options: GetProductCardOptions, _config?: AxiosRequestConfig) : Promise<ProductCardModel>
  {
    return this.axios.post<ProductCardModel>(`MpCard/GetProductCard`, options, _config).then(getAxiosData)
  }
  

  transferProductCards(options: TransferProductCardsOptions, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`MpCard/TransferProductCards`, options, _config).then(getAxiosData)
  }
  

  generateBarcodesWB(_config?: AxiosRequestConfig) : Promise<string[]>
  {
    return this.axios.post<string[]>(`MpCard/GenerateBarcodesWB`, null, _config).then(getAxiosData)
  }
  

  saveCardVariant(variant: ProductCardVariantUpdateModel, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.post<string>(`MpCard/SaveCardVariant`, variant, _config).then(getAxiosData)
  }
  

  linkVariant(request: LinkVariantRequest, _config?: AxiosRequestConfig) : Promise<string>
  {
    return this.axios.post<string>(`MpCard/LinkVariant`, request, _config).then(getAxiosData)
  }
  

}
